import GoogleCommuteCalculator from "./GoogleCommuteCalc";
import MapGLCommuteCalculator from "./MapGLCommuteCalc";
import React from "react";
import { useStateManagerContext } from "~/context/stateManager";
import { useLocalContent } from "~/sdks/LocalContent/context";
import { LocalContentProps } from "~/sdks/LocalContent/types";

export interface CommuteCalculatorProps {
  className?: string;
  onClose: () => void;
}

const CommuteCalculator = ({ className, onClose }: CommuteCalculatorProps) => {
  const { sdkState } = useStateManagerContext<LocalContentProps>();
  const { setActivePOI } = useLocalContent();
  const isGoogleMapProvider = sdkState.options?.mapProvider === "google";

  const googleOnClose = () => {
    onClose();
    setActivePOI(undefined);
  };

  if (isGoogleMapProvider) {
    return (
      <GoogleCommuteCalculator onClose={googleOnClose} className={className} />
    );
  }

  return <MapGLCommuteCalculator onClose={onClose} className={className} />;
};

export default CommuteCalculator;
